// extracted by mini-css-extract-plugin
export default {"empty":"LiveBadge_empty__wLy-p","liveContainer":"LiveBadge_liveContainer__BiuHH","onair":"LiveBadge_onair__bLimf","onair_wave":"LiveBadge_onair_wave__O7++c"};